<template>
  <v-app>
    <v-app-bar app color="#071136">
      <v-toolbar-title class="headline text-uppercase">
        <span>7</span>
        <span class="font-weight-light">VÉGE</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content>
      <div class="main">
        <v-row align="center" justify="center">
          <v-col class="text-center" cols="12">
            <h1 class="display-1 font-weight-thin mb-4">Hétvége van?</h1>
            <h4 class="subheading">{{isWeekend}}</h4>
          </v-col>
        </v-row>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import moment from 'moment';

export default {
  name: 'App',
  components: {},
  beforeMount () {
    setInterval(() => {
      this.days = moment().day();
      this.hours = moment().hour();
    }, 1000)
  },
  data: () => ({
    days: moment().day(),
    hours: moment().hour(),
  }),
  computed: {
    isWeekend() {
      if(this.days === 0 || this.days === 6){
        return 'IGEN';
      }
      if((this.days > 0 && this.days < 3) || (this.days === 3 && this.hours < 12)){
        return 'Még igen';
      }
      if((this.days > 3 && this.days < 6) || (this.days === 3 && this.hours > 11)){
        return 'Már igen';
      }

      return 'NEM';
    }
  }
};
</script>

<style>
.main {
    background: url('assets/wall.jpg');
    background-size: cover;
    height: 100%;
    z-index: 2;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 0 1rem;
}
</style>